












































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import { formRules } from '@/common/util/validator';
import { WareHouse, Dock } from '@/http';
import { enums } from '@/common/enums';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg,
    },
})
export default class platformManagement extends Vue {
    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        formData: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public stateType = enums.storeState;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public total = 10;
    public labelPosition: string = 'right';
    public tableData: any = [];

    public searchValue: any = {
        wareHouseId: '',
        isEnabled: '',
        orderBy: '',
        ASC: true,
    };

    public timeList = [];
    public warehouseList = [];
    public created() {}
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        this.GetWarehouseList();
        this.loadData();
    }

    /**
     * 获取仓库列表
     */
    public async GetWarehouseList() {
        await WareHouse.GetWareHouseList({
            enabled: true,
            skip: -1,
            count: -1,
        }).then((res) => {
            this.warehouseList = res.data;
        });
    }
    public async loadData() {
        this.loading = true;
        try {
            let res = await Dock.GetDockList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch {
            this.loading = false;
        }
    }
    /**查询 */
    public searchFunc() {
        this.loadData();
        // this.$refs.pagination.handleCurrentChange(1);
        // this.searchPagin.skip = 0;
    }
    /**重置 */
    public resetSearchValue() {
        this.searchValue = {
            wareHouseId: '',
            isEnabled: '',
            orderBy: '',
            ASC: true,
        };
        this.timeList = [];
        this.searchFunc();
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadData();
    }

    public formData: any = {
        wareHouseId: '',
        name: '',
        isEnabled: true,
    };
    public title = '';
    public dockId = '';
    public addNew() {
        this.title = '新增月台';
        this.formData = {
            wareHouseId: '',
            isEnabled: true,
        };
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
        this.dialogVisible = true;
    }
    public async toEdit(id) {
        this.dockId = id;
        this.GetWarehouseList();
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
        this.title = '编辑月台';
        await Dock.GetDockDetail(id).then((res) => {
            this.formData = res;
            let wareHouseIdList = [];
            this.warehouseList.forEach((e) => {
                wareHouseIdList.push(e.id);
            });
            if (wareHouseIdList.indexOf(this.formData.wareHouseId) == -1) {
                this.formData.wareHouseId = '';
            }
        });
        this.dialogVisible = true;
    }

    public save() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增月台') {
                    await Dock.AddDock(this.formData);
                    this.$message.success('新增成功!');
                    this.dialogVisible = false;
                    this.searchFunc();
                } else {
                    await Dock.EditDock(this.dockId, this.formData);
                    this.$message.success('编辑成功!');
                    this.dialogVisible = false;
                    this.searchFunc();
                }
            }
        });
    }
    public handleClose() {
        this.dialogVisible = false;
    }
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
}
